import { Helmet } from 'react-helmet'
import config from '../../constants/global'

const SeoHelmet = ({ title, titleSuffix = '', description, keywords, image, url }) => {
  const renderTitle = [title, titleSuffix, 'Sokooni Marketplace'].filter(Boolean).join(' | ')

  const renderIfNotEmpty = (value, content = []) => {
    if (!value) return null

    return content.map((item) => item)
  }

  return (
    <Helmet>
      {renderIfNotEmpty(title, [
        <title key="title">{renderTitle}</title>,
        <meta property="og:title" content={renderTitle} key="og:title" />,
        <meta name="twitter:title" content={renderTitle} key="twitter:title" />,
      ])}

      {renderIfNotEmpty(description, [
        <meta name="description" content={description} key="description" />,
        <meta property="og:description" content={description} key="og:description" />,
        <meta name="twitter:description" content={description} key="twitter:description" />,
      ])}
      {renderIfNotEmpty(keywords, [<meta name="keywords" content={keywords} key="keywords" />])}

      {renderIfNotEmpty(image, [
        <meta property="og:image" content={image} key="og:image" />,
        <meta name="twitter:image" content={image} key="twitter:image" />,
      ])}

      {renderIfNotEmpty(keywords, [<meta name="keywords" content={keywords} key="keywords" />])}

      {renderIfNotEmpty(url, [
        <meta property="og:url" content={config.appUrl + url} key="og:url" />,
        <link rel="canonical" href={config.appUrl + url} key="canonical" />,
      ])}
    </Helmet>
  )
}

export default SeoHelmet
